import { render } from "./RealEstateAgentPage.vue?vue&type=template&id=01e0b194&ts=true"
import script from "./RealEstateAgentPage.vue?vue&type=script&lang=ts"
export * from "./RealEstateAgentPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__